export default __webpack_public_path__ + "static/media/noa-20.16a204fe.jpg";